/*
 * @Author: Dom
 * @Date: 2022-05-15 18:29:26
 * @LastEditTime: 2022-05-22 18:46:03
 * @LastEditors: Dom
 * @FilePath: \seller-web\src\views\user\component\forgetpassword\locales\zh-TW.ts
 */
export default{
    'page.confirmtxt':'確定',
    'page.ctrltxt':'取消',
    'page.btnchangetxt':'換一換',
    'page.verificationtxt':'獲取驗證碼',
    'page.verificationtxtrepeat':'重新獲取驗證碼',
    'page.user.forgetpassword.email.tips':'輸入需要找回密碼的郵箱賬號',
    'page.user.forgetpassword.email.required':'輸入正確的郵箱賬號',
    'page.user.forgetpassword.emailtitle':'郵箱找回密碼',
    'page.user.forgetpassword.phonetitle':'手機號找回密碼',
    'page.user.forgetpassword.sendemailstart.tips':'請在發送郵件',
    'page.user.forgetpassword.sendtime.tips':'60分鐘',
    'page.user.forgetpassword.sendemailend.tips':'內前往郵箱驗證',
    'page.user.forgetpassword.sendemail.btntxt':'發送郵件',
    'page.user.forgetpassword.phonenumber.tips':'輸入綁定手機號碼',
    'page.user.forgetpassword.phonenumber.required':'輸入正確手機號碼',
    'page.user.forgetpassword.checknumber.tips':'輸入圖形驗證碼',
    'page.user.forgetpassword.checknumber.required':'請輸入圖形驗證碼',
    'page.user.forgetpassword.msgnumber.tips':'輸入短信驗證碼',
    'page.user.forgetpassword.msgnumber.required':'請輸入短信驗證碼',
    'page.user.forgetpassword.countdown.tips':'秒後重新發送',
    'page.user.forgetpassword.newpassword.tips':'設置新密碼',
    'page.user.forgetpassword.newpassword.required':'請輸入新密碼',
    'page.user.forgetpassword.confirmpassword.tips':'確認新密碼',
    'page.user.forgetpassword.confirmpassword.required':'再次輸入密碼',
    'page.user.forgetpassword.confirmpassword.required.compare':'兩次密碼不一致',
    'page.user.forgetpassword.phonecode.errormsg':'獲取圖形驗證碼失敗!',
    'page.user.forgetpassword.smscode.errormsg':'短信發送失敗!',
    'page.user.forgetpassword.smscode.msg':'短信已發出，請註意查收驗證碼!',
    'page.user.forgetpassword.email.msg':'郵件發送成功，請盡快登錄郵箱驗證!',
    'page.user.forgetpassword.email.errormsg':'發送郵件失敗!',
    'page.user.forgetpassword.phone.msg':'密碼找回成功!',
    'page.user.forgetpassword.phone.errormsg':'密碼找回失敗!',
}
